import React from 'react';

import type { TransactionType } from 'types/api/transaction';

import { useI18n } from 'lib/i18n/context';
import Tag from 'ui/shared/chakra/Tag';

import { TX_TYPE_KEY_MAP } from './i18n';

export interface Props {
  types: Array<TransactionType>;
  isLoading?: boolean;
  variant?: 'default' | 'explorer';
}

const TYPES_ORDER: Array<TransactionType> = [
  'blob_transaction',
  'rootstock_remasc',
  'rootstock_bridge',
  'token_creation',
  'contract_creation',
  'token_transfer',
  'contract_call',
  'coin_transfer',
];

const TxType = ({ types, isLoading, variant = 'default' }: Props) => {
  const { t } = useI18n();
  const typeToShow = types.sort((t1, t2) => TYPES_ORDER.indexOf(t1) - TYPES_ORDER.indexOf(t2))[0];

  let labelKey: string;
  let colorScheme;

  switch (typeToShow) {
    case 'contract_call':
      labelKey = TX_TYPE_KEY_MAP.contract_call;
      colorScheme = 'blue';
      break;
    case 'blob_transaction':
      labelKey = TX_TYPE_KEY_MAP.blob_transaction;
      colorScheme = 'yellow';
      break;
    case 'contract_creation':
      labelKey = TX_TYPE_KEY_MAP.contract_creation;
      colorScheme = 'blue';
      break;
    case 'token_transfer':
      labelKey = TX_TYPE_KEY_MAP.token_transfer;
      colorScheme = 'orange';
      break;
    case 'token_creation':
      labelKey = TX_TYPE_KEY_MAP.token_creation;
      colorScheme = 'orange';
      break;
    case 'coin_transfer':
      labelKey = TX_TYPE_KEY_MAP.coin_transfer;
      colorScheme = 'orange';
      break;
    case 'rootstock_remasc':
      labelKey = TX_TYPE_KEY_MAP.rootstock_remasc;
      colorScheme = 'blue';
      break;
    case 'rootstock_bridge':
      labelKey = TX_TYPE_KEY_MAP.rootstock_bridge;
      colorScheme = 'blue';
      break;
    default:
      labelKey = 'common.transaction';
      colorScheme = 'purple';

  }

  return (
    <Tag
      colorScheme={ colorScheme }
      bgColor={ variant === 'explorer' ? '#171717' : '#14DCAC1A' }
      borderWidth={ variant === 'explorer' ? '1px' : undefined }
      borderColor={ variant === 'explorer' ? '#222222' : undefined }
      color={ variant === 'explorer' ? '#FFFFFF' : 'green.400' }
      fontSize="12px"
      fontWeight={ variant === 'explorer' ? 500 : undefined }
      lineHeight="16px"
      fontFamily="'Space Grotesk', var(--chakra-fonts-body)"
      borderRadius="4px"
      px="8px"
      py="2px"
      minH="24px"
      maxW="100%"
      isTruncated
      isLoading={ isLoading }
    >
      { t(labelKey) }
    </Tag>
  );
};

export default TxType;
